import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBurger = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 13.5,
			width: 13,
			height: 1,
			rx: .5,
			stroke: "#333333"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 8.5,
			width: 13,
			height: 1,
			rx: .5,
			stroke: "#333333"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 3.5,
			width: 13,
			height: 1,
			rx: .5,
			stroke: "#333333"
		})
	]
});
export default SvgIconBurger;
